"use client";

import { useEffect, useRef, useState } from "react";

interface WistiaVideoProps {
  videoId: string;
}

const WistiaVideo = ({ videoId }: WistiaVideoProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const existingScript = document.querySelector(
      'script[src="https://fast.wistia.com/assets/external/E-v1.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://fast.wistia.com/assets/external/E-v1.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, [isVisible]);

  return (
    <div className="w-full max-w-3xl mx-auto rounded-lg overflow-hidden">
      <div
        ref={containerRef}
        className="wistia_responsive_padding"
        style={{ padding: "56.25% 0 0 0", position: "relative" }}
      >
        <div
          className="wistia_responsive_wrapper"
          style={{
            height: "100%",
            left: 0,
            position: "absolute",
            top: 0,
            width: "100%",
          }}
        >
          <div
            className={`wistia_embed wistia_async_${videoId} videoFoam=true`}
            style={{ height: "100%", width: "100%" }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export { WistiaVideo };
